import filtersMixin from 'libraryScripts/listings/mixins/listingFiltersMixin';
import developmentMixin from './mixins/developmentListingDevelopmentMixin';
import propertiesMixin from './mixins/developmentListingPropertiesMixin';;
import mapMixin from 'libraryScripts/listings/mixins/listingMapMixin';

export default (Vue, blockHelper) => {
    
    if (document.getElementsByClassName('development-listing-results').length > 0) {
        new Vue({
            mixins: [filtersMixin, propertiesMixin, mapMixin, developmentMixin],
            el: '.development-listing-results',
            data: function() {
                return {
                    vm: {
                        developments: [],
                        mapToggle: {},
                        siteHeaderElement: undefined,
                    }
                }
            },
            methods: {
                isMobile: function() {
                    const breakpoint = getComputedStyle(this.$el).getPropertyValue('--mobile-width');
                    return (!window.matchMedia(`(min-width: ${breakpoint})`).matches);
                }
            },
            async mounted() {
                this.siteHeaderElement = document.querySelector('[data-controller="site-header"]');
                if(this.siteHeaderElement) {
                    this.siteHeaderElement.classList.add('is-property-listing');
                }
                this.initFilters();
                if(!this.isMobile()) {
                    this.isMapActive = true;
                    this.state.map = true;
                }
                this.initMap();
                this.initData(blockHelper);
            }
        })
    }

};


